import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "../modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalDetailService } from "src/app/core/service/modal-detail.service";


@Component({
  selector: 'app-modal-view-produit-detail',
  templateUrl: './modal-view-produit-detail.component.html',
  styleUrls: ['./modal-view-produit-detail.component.scss']
})
export class ModalViewProduitDetailComponent implements OnInit {

  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  modalRef:BsModalRef
  itemsStatutInitialized=[]

  itemProduit: any = {};
  itemsFiliale: any;
  itemsStatut: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService:BsModalService,
    private detailModalService:ModalDetailService
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    setTimeout(() => {
      if (this.currentData) {
       this.itemProduit = this.currentData
      }
    }, 50);
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalReseau() {
    if(!this.itemProduit.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 54581554500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemProduit.reseau_de_soin_id,reseau_de_soin_libelle:this.itemProduit.reseau_de_soin_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  
  
  }
  openModalPrestataireReseau(){}

  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsStatutInitialized = [...this.itemsStatut];
            this.itemsStatutInitialized.sort((a, b) => this.customSort(a, b));
            this.get_nombre_par_famille();
            this.getItemsPrimeProduit();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }
  
  get_nombre_par_famille() {
    this.itemProduit.nombre_personnes_famille = 0;
    this.itemsStatutInitialized.map((isi) => {
      this.itemProduit.nombre_personnes_famille += Number(isi.nombre_autorise);
    });
  }

  getItemsPrimeProduit() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        produit_id: this.itemProduit.id,
      },
    };
    // debugger

    this.busyGet = this.restClient
      .post("primeProduit/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            let itemsPrime = res["items"];
            if (itemsPrime && itemsPrime.length) {
              itemsPrime.map((ip) => {
                ip.codification =
                  this.itemsStatut &&
                  this.itemsStatut.filter((ig) => ig.id == ip.statut_id)
                    ? this.itemsStatut.filter((ig) => ig.id == ip.statut_id)[0]
                        .codification
                    : "";
              });
            }

            this.itemsStatutInitialized.map((isi) => {
              if (isi.codification == "A") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "A")[0]
                    : {};
                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "C") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "C")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "E") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "E")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "ASC") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "ASC")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "AU") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "AU")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
            });
            this.get_nombre_par_famille();

            console.log("itemsPrime: ", itemsPrime);
          } else {
            // this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          // this.itemsReseauDeSoin = [];
        }
      );
  }
  
  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }

  openDetailModal(type){
    let data={}
    // if(type == 'reseau_de_soin'){
    //   data = this.items.filter(ig=>ig.id ==this.itemToSave.garant_id)[0]
    //   this.detailModalService.onPenDetailModal(data,type,80)
    // }
    // if(type == 'produit'){
    //   data = this.itemsGarantProduit.filter(igp=>igp.id ==this.itemToSave.produit_id)[0]
    //   this.detailModalService.onPenDetailModal(data,type,90)
    // }
  
  }

  ngOnInit() {
    this.getItemsFiliale();
    this.getItemsStatut()
  }

}
